var map = {
	"./1/share1.png": "cfxt",
	"./1/translation1.png": "ghHS",
	"./10/share10.png": "PvZo",
	"./10/translation10.png": "thar",
	"./11/share11.png": "9ngA",
	"./11/translation11.png": "MdMt",
	"./12/share12.png": "aZ26",
	"./12/translation12.png": "y0a1",
	"./13/share13.png": "69K9",
	"./13/translation13.png": "Vq7u",
	"./14/share14.png": "ztEY",
	"./14/translation14.png": "B8fC",
	"./15/share15.png": "3W+7",
	"./15/translation15.png": "zkkx",
	"./16/share16.png": "jdbj",
	"./16/translation16.png": "jlRH",
	"./17/share17.png": "J2L/",
	"./17/translation17.png": "u2FP",
	"./18/share18.png": "aQPb",
	"./18/translation18.png": "JcJF",
	"./19/share19.png": "ro0r",
	"./19/translation19.png": "EDTN",
	"./2/share2.png": "OLwA",
	"./2/translation2.png": "vCzL",
	"./20/share20.png": "bl9G",
	"./20/translation20.png": "ThHB",
	"./21/share21.png": "e8IF",
	"./21/translation21.png": "Ju/T",
	"./22/share22.png": "q+aj",
	"./22/translation22.png": "2pEX",
	"./23/share23.png": "nHrm",
	"./23/translation23.png": "ZTJV",
	"./24/share24.png": "0ZB9",
	"./24/translation24.png": "cVFj",
	"./25/share25.png": "XXvF",
	"./25/translation25.png": "9tvu",
	"./26/share26.png": "hjNC",
	"./26/translation26.png": "nlhJ",
	"./27/share27.png": "g2C2",
	"./27/translation27.png": "ajo8",
	"./28/share28.png": "vc4P",
	"./28/translation28.png": "Y1UL",
	"./29/share29.png": "6uJT",
	"./29/translation29.png": "S97Z",
	"./3/share3.png": "o+wJ",
	"./3/translation3.png": "PWuy",
	"./30/share30.png": "v9Ho",
	"./30/translation30.png": "oeXZ",
	"./31/share31.png": "FQnv",
	"./31/translation31.png": "cgzn",
	"./32/share32.png": "Pfow",
	"./32/translation32.png": "QDH0",
	"./33/share33.png": "fHD5",
	"./33/translation33.png": "O0XH",
	"./34/share34.png": "sPfc",
	"./34/translation34.png": "PCLv",
	"./35/share35.png": "8nvd",
	"./35/translation35.png": "z6gw",
	"./36/share36.png": "mCvP",
	"./36/translation36.png": "uuXr",
	"./37/share37.png": "h6P+",
	"./37/translation37.png": "wjYj",
	"./38/share38.png": "Fph7",
	"./38/translation38.png": "PXbR",
	"./39/share39.png": "ltaB",
	"./39/translation39.png": "ZeUt",
	"./4/share4.png": "sAJZ",
	"./4/translation4.png": "HzKc",
	"./40/share40.png": "Awv/",
	"./40/translation40.png": "fAXZ",
	"./41/share41.png": "/sjt",
	"./41/translation41.png": "msI5",
	"./42/share42.png": "Y8yX",
	"./42/translation42.png": "+HVw",
	"./43/share43.png": "gxBO",
	"./43/translation43.png": "Ga5z",
	"./44/share44.png": "SDDt",
	"./44/translation44.png": "iBzz",
	"./45/share45.png": "nMPB",
	"./45/translation45.png": "iwJ1",
	"./5/share5.png": "g3Gr",
	"./5/translation5.png": "msPn",
	"./6/share6.png": "AL9U",
	"./6/translation6.png": "veLm",
	"./7/share7.png": "TL6B",
	"./7/translation7.png": "UmwY",
	"./8/share8.png": "6uYK",
	"./8/translation8.png": "LOkk",
	"./9/share9.png": "DHFC",
	"./9/translation9.png": "UgJt",
	"./bg.png": "dowx",
	"./layer.png": "FhnS",
	"./share_hand.png": "9W4V",
	"./sharebtn.png": "+YT8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LbdV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result ^\.\/.*\.png$
// module id = LbdV
// module chunks = 0